import React from 'react'
import { useNavigate, useLocation } from 'react-router-dom'
import Sidebar from './Sidebar'
import MobileNav from './MobileNav'
import { useAuth } from '../contexts/AuthContext'
import { signOut } from '../lib/supabase'
import { NAV_SECTIONS } from '../lib/navConfig'

// Find the page label from navConfig for the topbar
const getPageLabel = (pathname) => {
  for (const section of NAV_SECTIONS) {
    for (const item of section.items) {
      if (pathname.startsWith(item.to)) return { section: section.label, page: item.label }
    }
  }
  if (pathname.includes('/dashboard/finance')) return { section: 'Finance & Control', page: 'Finance Dashboard' }
  if (pathname.includes('/dashboard/ops')) return { section: 'Farm Operations', page: 'Operations Dashboard' }
  if (pathname.includes('/dashboard/staff')) return { section: 'Farm Operations', page: 'My Dashboard' }
  return { section: '', page: 'Dashboard' }
}

export default function AppLayout({ title, children }) {
  const { profile, userRole } = useAuth()
  const navigate = useNavigate()
  const location = useLocation()

  const { section, page } = getPageLabel(location.pathname)
  const displayTitle = title || page

  const ugandaDate = new Date().toLocaleDateString('en-UG', {
    timeZone: 'Africa/Kampala',
    weekday: 'short', day: 'numeric', month: 'short', year: 'numeric'
  })

  const ugandaTime = new Date().toLocaleTimeString('en-UG', {
    timeZone: 'Africa/Kampala',
    hour: '2-digit', minute: '2-digit'
  })

  const initials = profile?.full_name
    ? profile.full_name.split(' ').map(n => n[0]).join('').toUpperCase().slice(0, 2) : '?'

  return (
    <div className="app-layout">
      <Sidebar />
      <div className="main">
        {/* TopBar */}
        <div className="topbar" style={{ display: 'flex', alignItems: 'center', gap: 12, padding: '0 24px', height: 56, borderBottom: '1px solid var(--border)', background: 'white', position: 'sticky', top: 0, zIndex: 10 }}>
          {/* Breadcrumb */}
          <div style={{ flex: 1 }}>
            {section && (
              <div style={{ fontSize: '0.65rem', color: 'var(--text-muted)', fontFamily: "'DM Mono',monospace", textTransform: 'uppercase', letterSpacing: '0.1em', marginBottom: 1 }}>
                {section}
              </div>
            )}
            <div style={{ fontWeight: 700, fontSize: '1rem', color: 'var(--green-deep)', fontFamily: "'Cormorant Garamond',serif" }}>
              {displayTitle}
            </div>
          </div>

          {/* Date + Time */}
          <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end', gap: 1 }}>
            <div style={{ fontSize: '0.72rem', color: 'var(--text-muted)', fontFamily: "'DM Mono',monospace" }}>{ugandaDate}</div>
            <div style={{ fontSize: '0.65rem', color: 'var(--text-muted)', fontFamily: "'DM Mono',monospace" }}>{ugandaTime} EAT</div>
          </div>

          {/* User chip — desktop only */}
          <div className="topbar-user" style={{ display: 'flex', alignItems: 'center', gap: 8, paddingLeft: 12, borderLeft: '1px solid var(--border)' }}>
            <div style={{ width: 30, height: 30, borderRadius: '50%', background: 'var(--green-deep)', color: 'white', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '0.7rem', fontWeight: 700 }}>
              {initials}
            </div>
            <div style={{ display: 'flex', flexDirection: 'column' }}>
              <div style={{ fontSize: '0.75rem', fontWeight: 600, color: 'var(--text)', lineHeight: 1.2 }}>
                {profile?.full_name?.split(' ')[0]}
              </div>
              <div style={{ fontSize: '0.6rem', color: 'var(--text-muted)', fontFamily: "'DM Mono',monospace", textTransform: 'uppercase' }}>
                {userRole === 'finance_admin' ? 'Finance Admin' : userRole === 'ops_admin' ? 'Operations' : 'Staff'}
              </div>
            </div>
          </div>
        </div>

        {/* Page content */}
        <div className="content">
          {children}
        </div>
      </div>
      <MobileNav />
    </div>
  )
}
